// **Axios imports
import axios from 'axios'

/**
 * returns array of tenant list
 */
export const getTenantList = async () => {
  const response = axios.get('tenants/list')
  return response
}

/**
 *
 * @param {string} tenantId
 * @returns array of user details for a tenant
 */
export const getTenantUserDetails = async (tenantId) => {
  const response = axios.get(`tenant-users/${tenantId}`)
  return response
}

/**
 *
 * @param {string} id
 * @param {boolean} enable
 * @returns
 */
export const enableDisableTenant = async (id, enable = false) => {
  const response = axios.post(`tenants/${enable ? 'enable' : 'disable'}/${id}`)
  return response
}

/**
 * 
 * @param {string} userId 
 * @returns object {
    "challengeCount": {
        "mcq": 1,
        "programming": 1,
        "application": 0,
        "notebook": 0,
        "sql": 1
    },
    "databaseCount": 0
}
 */
export const getUserChallengeCount = async (userId) => {
  const response = axios.get(`users/${userId}/activity`)
  return response
}

/**
 *
 * @param {object} payload
 * @returns array of objects  content:[{domain:'gamil'}]
 */
export const getBlockedDomains = async (payload) => {
  const queryParams = new URLSearchParams()

  if (payload?.sortDir) queryParams.append('sortDirection', payload.sortDir)
  if (payload?.sortBy) queryParams.append('sortBy', payload.sortBy)
  if (payload?.query) queryParams.append('emailPattern', payload.query)
  if (payload?.pageSize) queryParams.append('size', payload.pageSize)
  queryParams.append('page', payload.page)

  const response = await axios.get(`block-domains?${queryParams.toString()}`)
  return response
}

/**
 *
 * @param {*} id
 * @returns
 */
export const blockDomain = async (domain) => {
  const response = axios.post(`block-domains`, { domain: domain })
  return response
}

/**
 *
 * @param {string} domain
 * @returns
 */
export const removeDomainFromBlacklist = async (domain) => {
  const response = axios.delete(`block-domains`, { data: { domain } })
  return response
}

export const getTenantCredit = async (tenantId) => {
  const response = await axios.get(`tenants/check-credits?tenantId=${tenantId}`)
  return response
}

/**
 * object ={startDate,endDate}
 * @returns
 */
export const getTenantInvoices = async (payload) => {
  const response = await axios.post(`invoices/list`, payload)
  return response
}

export const addTenantCredits = async (payload) => {
  const response = await axios.post(`credits/add-credit`, payload)
  return response
}

export const getAllAttempts = async (payload) => {
  const response = await axios.post(`candidate-attempts/latest`, payload)
  return response
}

// Coupons API

export const getCoupons = async (payload) => {
  const response = await axios.post(`coupons/all`, payload)
  return response
}

export const getCouponById = async (id) => {
  const response = await axios.get(`coupons/${id}`)
  return response
}

export const getCouponUsageHistory = async (couponCode, tenantId) => {
  const response = await axios.get(`coupons/history`, {
    params: {
      couponCode,
      tenantId
    }
  })
  return response
}

export const createCoupon = async (payload) => {
  const response = await axios.post(`coupons`, payload)
  return response
}

export const updateCoupon = async (payload) => {
  const response = await axios.put(`coupons`, payload)
  return response
}

export const editEventDetails = async (eventId, payload) => {
  const response = await axios.put(
    `candidate-attempt-events/${eventId}`,
    payload
  )
  return response
}

export const deleteEventDetails = async (eventId) => {
  const response = await axios.delete(`candidate-attempt-events/${eventId}`)
  return response
}
